import { FractionTypeNames } from '~/bootcamp/Activities/Fractions/Fractions.type'
import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'
import { shuffle } from '~/utils'

interface RangeModel {
  numerator: { min: number; max: number }
  denominator: { min: number; max: number }
  quotient?: { min: number; max: number }
  variation: number
}

interface DifficultyLevelRangeMapModel {
  [key: number]: RangeModel
}

export interface FractionModel {
  numerator: number
  denominator: number
  quotient: number
  type: string
}

export interface FractionTypes2QuestionModel {
  typeToSelect: string
  fractions: FractionModel[]
}

const DIFFICULTY_LEVEL_RANGE_MAP: DifficultyLevelRangeMapModel = {
  1: { numerator: { min: 1, max: 10 }, denominator: { min: 2, max: 8 }, quotient: { min: 1, max: 5 }, variation: 350 },
  2: { numerator: { min: 1, max: 10 }, denominator: { min: 2, max: 8 }, quotient: { min: 1, max: 5 }, variation: 350 },
}

export function getFractionType2QuestionData(difficultyLevel: number): FractionTypes2QuestionModel {
  const range = DIFFICULTY_LEVEL_RANGE_MAP[difficultyLevel]

  let denominator = getRandomInt(range.denominator.min, range.denominator.max)
  let numerator = getRandomInt(range.numerator.min, denominator - 1)
  let quotient = 0
  const proper: FractionModel = { denominator, numerator, quotient, type: FractionTypeNames.PROPER }

  denominator = getRandomInt(range.denominator.min, range.denominator.max)
  numerator = getRandomInt(denominator + 1, range.numerator.max)
  quotient = 0
  const improper: FractionModel = { denominator, numerator, quotient, type: FractionTypeNames.IMPROPER }

  denominator = getRandomInt(range.denominator.min, range.denominator.max)
  numerator = getRandomInt(range.numerator.min, denominator - 1)
  quotient = getRandomInt(range.quotient?.min || 0, range.quotient?.max || 0)
  const mixed: FractionModel = { denominator, numerator, quotient, type: FractionTypeNames.MIXED }

  const randomNum = Math.random()
  const fractionType =
    randomNum > 0.3
      ? randomNum < 0.6
        ? FractionTypeNames.PROPER
        : FractionTypeNames.IMPROPER
      : FractionTypeNames.MIXED

  return { typeToSelect: fractionType, fractions: shuffle<FractionModel>([proper, improper, mixed]) }
}
